module.exports = __webpack_public_path__ + "img/Bergungsgruppe.46ba453c.svg";